const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/blog/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/blog/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type BlogPost = TherapistBlogPost;
type BlogListResponse = {
  data: BlogPost[];
  total: number;
  page: number;
};